import { apiUrl } from '@/config';

export class BaseApi {
  public readonly baseApiUrl: string;

  public constructor() {
    if (!apiUrl) throw new Error('Missing API_URL parameter');
    this.baseApiUrl = apiUrl;
  }
}
